import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=0dca2166&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./faq.vue?vue&type=style&index=0&id=0dca2166&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dca2166",
  null
  
)

export default component.exports